export default __webpack_public_path__ + "667401c7a84f544499bc4ee884466fb9.png";